
export class Subject<T> {
	private listeners = [] as ((data?: T) => void)[];
	public listen(callback: (data?: T) => void): () => void {
		this.listeners.push(callback);
		return () => {
			const index = this.listeners.indexOf(callback);
			if (index >= 0) {
				this.listeners.splice(index, 1);
			}
		};
	}

	next(data?: T) {
		for (const listener of this.listeners) {
			listener(data);
		}
	}
}
